import { schema } from "normalizr";

export const additionalQuestion = new schema.Entity("additionalQuestion");
export const additionalQuestionList = [additionalQuestion];
